'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LocalizedHtml, useFormatNumber, useI18n } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import { publishEvent } from '@udemy-v2/event-tracking';
import { aggregateCollectionStats, FALLBACK_COLLECTION_STATS, PlanPeriod, PlanPeriodStyle, SubscribeFromPageCookie, SubscriptionCTA, SubscriptionLearnMoreEvent } from '@udemy-v2/react-subscription-browse';
import { CollapsiblePurchaseSection } from '@/features/course-landing-page/components/collapsible-purchase-section/collapsible-purchase-section.react-component';
import { CLPPurchaseOption, useClpPurchaseContext, useClpSelectedOption } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useClpNoticeContext } from '@/features/course-landing-page/context/clp-notice-context-provider.react-component';
import styles from './non-catalog-pp-offer.module.scss';
import { useFeatures } from '@udemy-v2/react-experimentation';
import { CollapsiblePurchaseBoxContent, SUBSCRIPTION_SUB_VALUE_PROP_MSG } from '@/features/course-landing-page/components/subscription-purchase-content/collapsible-purchase-box-content.react-component';
const UI_REGION = 'purchase_section_tab_non_catalog';
const SUBSCRIPTION_ATTRIBUTION_PATHS = ['/personal-plan', '/pricing'];
interface CategoryStats {
  isSubCopyEnabled?: boolean;
}
export const CollapsibleNonCatalogPPContent = categoryStats => {
  const $ = _c(113);
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    formatNumber
  } = useFormatNumber();
  const course = useClpCourse();
  const {
    nonCatalogPersonalPlan,
    nonCatalogSubscriptionCTAConfiguration,
    isEligibleForNonCatalogPPOffer
  } = useClpPurchaseContext();
  const {
    selectedPurchaseOption,
    setSelectedPurchaseOption
  } = useClpSelectedOption();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["change_cta_language_for_pp"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments
  } = useFeatures(t0);
  const changeCtaLangFeatureAssignment = featureVariantAssignments.get("change_cta_language_for_pp")?.configuration as {
    getStarted: boolean;
    getPersonalPlan: boolean;
  } | undefined;
  const clpNoticeContext = useClpNoticeContext();
  const subscriptionPriceBoxNotice = clpNoticeContext?.subscriptionPriceBoxNoticeData;
  const isExpanded = selectedPurchaseOption === CLPPurchaseOption.SUBSCRIPTION;
  if (!nonCatalogPersonalPlan) {
    return null;
  }
  const contentCollections = nonCatalogPersonalPlan.contentCollections;
  let T0;
  let T1;
  let ctaText;
  let ctaUrl;
  let handleCtaClick;
  let handleLearnMoreClick;
  let learnMoreTarget;
  let learnMoreText;
  let learnMoreUrl;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== categoryStats.isSubCopyEnabled || $[2] !== contentCollections || $[3] !== course.categories || $[4] !== course.id || $[5] !== formatNumber || $[6] !== gettext || $[7] !== interpolate || $[8] !== isEligibleForNonCatalogPPOffer || $[9] !== isExpanded || $[10] !== nonCatalogPersonalPlan || $[11] !== setSelectedPurchaseOption || $[12] !== subscriptionPriceBoxNotice?.subtitle_link_target || $[13] !== subscriptionPriceBoxNotice?.subtitle_link_text || $[14] !== subscriptionPriceBoxNotice?.subtitle_link_url) {
    const subscriptionPlanStats = contentCollections ? aggregateCollectionStats(contentCollections.map(_temp)) : FALLBACK_COLLECTION_STATS;
    const formattedMonthlyListPrice = nonCatalogPersonalPlan.formattedMonthlyAmount;
    let t10;
    if ($[33] !== gettext || $[34] !== subscriptionPriceBoxNotice?.subtitle_link_text) {
      t10 = subscriptionPriceBoxNotice?.subtitle_link_text ?? gettext("Learn more");
      $[33] = gettext;
      $[34] = subscriptionPriceBoxNotice?.subtitle_link_text;
      $[35] = t10;
    } else {
      t10 = $[35];
    }
    learnMoreText = t10;
    let t11;
    bb0: {
      const base = nonCatalogPersonalPlan.urlLearnMore ?? "https://udemy.com/personal-plan/";
      if (!isEligibleForNonCatalogPPOffer) {
        t11 = base;
        break bb0;
      }
      let t12;
      if ($[36] !== base || $[37] !== course.id) {
        const url = new URL(base);
        url.searchParams.set("non-catalog-course", course.id);
        t12 = url.toString();
        $[36] = base;
        $[37] = course.id;
        $[38] = t12;
      } else {
        t12 = $[38];
      }
      t11 = t12;
    }
    const subscriptionContextLearnMoreUrl = t11;
    learnMoreUrl = subscriptionPriceBoxNotice?.subtitle_link_url ?? subscriptionContextLearnMoreUrl;
    learnMoreTarget = subscriptionPriceBoxNotice?.subtitle_link_target === "new_tab" ? "_blank" : "_self";
    let t12;
    if ($[39] !== course.id) {
      const params = new URLSearchParams({
        "non-catalog-course": course.id
      });
      t12 = params.toString();
      $[39] = course.id;
      $[40] = t12;
    } else {
      t12 = $[40];
    }
    ctaUrl = `/subscription-checkout/express/?${t12}`;
    let t13;
    if ($[41] !== course.id || $[42] !== learnMoreUrl || $[43] !== nonCatalogPersonalPlan) {
      t13 = () => {
        if (SUBSCRIPTION_ATTRIBUTION_PATHS.some(path => learnMoreUrl.includes(path))) {
          SubscribeFromPageCookie.set("course_landing_page", parseInt(course.id, 10));
        }
        if (nonCatalogPersonalPlan) {
          publishEvent(new SubscriptionLearnMoreEvent({
            planId: nonCatalogPersonalPlan.id,
            planType: nonCatalogPersonalPlan.productType,
            uiRegion: UI_REGION,
            planPriceIds: nonCatalogPersonalPlan.planPriceOptionIds
          }));
        }
      };
      $[41] = course.id;
      $[42] = learnMoreUrl;
      $[43] = nonCatalogPersonalPlan;
      $[44] = t13;
    } else {
      t13 = $[44];
    }
    handleLearnMoreClick = t13;
    let t14;
    if ($[45] !== course.id) {
      t14 = () => {
        SubscribeFromPageCookie.set("course_landing_page", parseInt(course.id, 10));
      };
      $[45] = course.id;
      $[46] = t14;
    } else {
      t14 = $[46];
    }
    handleCtaClick = t14;
    let t15;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = classNames("ud-text-md");
      $[47] = t15;
    } else {
      t15 = $[47];
    }
    let t16;
    if ($[48] !== gettext) {
      t16 = gettext("Subscribe and save");
      $[48] = gettext;
      $[49] = t16;
    } else {
      t16 = $[49];
    }
    let t17;
    if ($[50] !== t16) {
      t17 = <span className={t15}>{t16}</span>;
      $[50] = t16;
      $[51] = t17;
    } else {
      t17 = $[51];
    }
    let t18;
    if ($[52] !== formattedMonthlyListPrice) {
      t18 = <PlanPeriod listPriceText={formattedMonthlyListPrice} trialPeriodDays={0} style={PlanPeriodStyle.TITLE} />;
      $[52] = formattedMonthlyListPrice;
      $[53] = t18;
    } else {
      t18 = $[53];
    }
    let t19;
    if ($[54] !== categoryStats.isSubCopyEnabled || $[55] !== gettext) {
      t19 = categoryStats.isSubCopyEnabled && <div className={styles["sub-value-prop-text"]}><LocalizedHtml html={gettext(SUBSCRIPTION_SUB_VALUE_PROP_MSG)} interpolate={{
          bold: <span className="ud-text-bold" />
        }} /></div>;
      $[54] = categoryStats.isSubCopyEnabled;
      $[55] = gettext;
      $[56] = t19;
    } else {
      t19 = $[56];
    }
    let t20;
    if ($[57] !== t17 || $[58] !== t18 || $[59] !== t19) {
      t20 = <>{t17}{t18}{t19}</>;
      $[57] = t17;
      $[58] = t18;
      $[59] = t19;
      $[60] = t20;
    } else {
      t20 = $[60];
    }
    const title = t20;
    let t21;
    if ($[61] !== gettext) {
      t21 = config => {
        if (!config) {
          return gettext("Start subscription");
        }
        if (config.getStarted && !config.getPersonalPlan) {
          return gettext("Get started");
        }
        if (!config.getStarted && config.getPersonalPlan) {
          return gettext("Get Personal Plan");
        }
        return gettext("Start subscription");
      };
      $[61] = gettext;
      $[62] = t21;
    } else {
      t21 = $[62];
    }
    ctaText = t21;
    T1 = CollapsiblePurchaseSection;
    t6 = isExpanded;
    t7 = title;
    if ($[63] !== setSelectedPurchaseOption) {
      t8 = () => setSelectedPurchaseOption(CLPPurchaseOption.SUBSCRIPTION);
      $[63] = setSelectedPurchaseOption;
      $[64] = t8;
    } else {
      t8 = $[64];
    }
    let t22;
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <Icon className={styles["value-prop-icon"]} glyph="verified" color="positive" size="small" label="" />;
      $[65] = t22;
    } else {
      t22 = $[65];
    }
    let t23;
    if ($[66] !== gettext) {
      t23 = gettext("<span class=\"bold\">Get this course for free</span> when you subscribe. Terms apply.");
      $[66] = gettext;
      $[67] = t23;
    } else {
      t23 = $[67];
    }
    let t24;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = {
        bold: <span className="ud-text-bold" />
      };
      $[68] = t24;
    } else {
      t24 = $[68];
    }
    if ($[69] !== t23) {
      t9 = <div className={styles["value-prop-badge"]}>{t22}<span className={styles["value-prop-text"]}><LocalizedHtml html={t23} interpolate={t24} /></span></div>;
      $[69] = t23;
      $[70] = t9;
    } else {
      t9 = $[70];
    }
    T0 = BlockList;
    t1 = "small";
    t2 = "tight";
    t3 = "left";
    t4 = categoryStats.isSubCopyEnabled && <CollapsiblePurchaseBoxContent coursesCount={formatNumber(subscriptionPlanStats.numberOfCourses)} categoryName={course.categories[0]?.name} />;
    t5 = !categoryStats.isSubCopyEnabled && <BlockList.Item icon={<Icon label="" size="xsmall" glyph="video-playlist" />}><span className="ud-text-sm">{interpolate(gettext("Access to %(courses_count)s+ top-rated courses"), {
          courses_count: formatNumber(subscriptionPlanStats.numberOfCourses)
        }, true)}</span></BlockList.Item>;
    $[1] = categoryStats.isSubCopyEnabled;
    $[2] = contentCollections;
    $[3] = course.categories;
    $[4] = course.id;
    $[5] = formatNumber;
    $[6] = gettext;
    $[7] = interpolate;
    $[8] = isEligibleForNonCatalogPPOffer;
    $[9] = isExpanded;
    $[10] = nonCatalogPersonalPlan;
    $[11] = setSelectedPurchaseOption;
    $[12] = subscriptionPriceBoxNotice?.subtitle_link_target;
    $[13] = subscriptionPriceBoxNotice?.subtitle_link_text;
    $[14] = subscriptionPriceBoxNotice?.subtitle_link_url;
    $[15] = T0;
    $[16] = T1;
    $[17] = ctaText;
    $[18] = ctaUrl;
    $[19] = handleCtaClick;
    $[20] = handleLearnMoreClick;
    $[21] = learnMoreTarget;
    $[22] = learnMoreText;
    $[23] = learnMoreUrl;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    ctaText = $[17];
    ctaUrl = $[18];
    handleCtaClick = $[19];
    handleLearnMoreClick = $[20];
    learnMoreTarget = $[21];
    learnMoreText = $[22];
    learnMoreUrl = $[23];
    t1 = $[24];
    t2 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
  }
  let t10;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon label="" size="xsmall" glyph="coupon" />;
    $[71] = t10;
  } else {
    t10 = $[71];
  }
  let t11;
  if ($[72] !== gettext) {
    t11 = gettext("Cancel anytime");
    $[72] = gettext;
    $[73] = t11;
  } else {
    t11 = $[73];
  }
  let t12;
  if ($[74] !== t11) {
    t12 = <BlockList.Item icon={t10}><span className="ud-text-sm">{t11}</span></BlockList.Item>;
    $[74] = t11;
    $[75] = t12;
  } else {
    t12 = $[75];
  }
  let t13;
  if ($[76] !== categoryStats.isSubCopyEnabled || $[77] !== handleLearnMoreClick || $[78] !== learnMoreTarget || $[79] !== learnMoreText || $[80] !== learnMoreUrl) {
    t13 = !categoryStats.isSubCopyEnabled && <BlockList.Item icon={<Icon label="" size="xsmall" glyph="info-outline" />}><a className={styles["learn-more-link"]} data-purpose="non-catalog-pp-learn-more-link" href={learnMoreUrl} target={learnMoreTarget} onClick={handleLearnMoreClick}>{learnMoreText}</a></BlockList.Item>;
    $[76] = categoryStats.isSubCopyEnabled;
    $[77] = handleLearnMoreClick;
    $[78] = learnMoreTarget;
    $[79] = learnMoreText;
    $[80] = learnMoreUrl;
    $[81] = t13;
  } else {
    t13 = $[81];
  }
  let t14;
  if ($[82] !== T0 || $[83] !== t1 || $[84] !== t12 || $[85] !== t13 || $[86] !== t2 || $[87] !== t3 || $[88] !== t4 || $[89] !== t5) {
    t14 = <T0 size={t1} padding={t2} iconAlignment={t3}>{t4}{t5}{t12}{t13}</T0>;
    $[82] = T0;
    $[83] = t1;
    $[84] = t12;
    $[85] = t13;
    $[86] = t2;
    $[87] = t3;
    $[88] = t4;
    $[89] = t5;
    $[90] = t14;
  } else {
    t14 = $[90];
  }
  const T2 = SubscriptionCTA;
  const t15 = styles["cta-container"];
  const t16 = UI_REGION;
  const t17 = categoryStats.isSubCopyEnabled;
  const t18 = "non-catalog-pp-cta";
  const t19 = "primary";
  const t20 = parseInt(course.id, 10);
  const t21 = false;
  const t22 = nonCatalogSubscriptionCTAConfiguration?.directCheckout ?? true;
  const t23 = nonCatalogSubscriptionCTAConfiguration?.purchaseCtaText ?? ctaText(changeCtaLangFeatureAssignment);
  let t24;
  if ($[91] !== ctaUrl) {
    t24 = {
      cta_1_url: ctaUrl
    };
    $[91] = ctaUrl;
    $[92] = t24;
  } else {
    t24 = $[92];
  }
  let t25;
  if ($[93] !== T2 || $[94] !== categoryStats.isSubCopyEnabled || $[95] !== course.frontendTrackingId || $[96] !== handleCtaClick || $[97] !== nonCatalogPersonalPlan || $[98] !== t15 || $[99] !== t16 || $[100] !== t20 || $[101] !== t22 || $[102] !== t23 || $[103] !== t24) {
    t25 = <T2 className={t15} uiRegion={t16} showSubtitle={t17} data-purpose={t18} offerCtaStyle={t19} onCTAClick={handleCtaClick} courseId={t20} courseTrackingId={course.frontendTrackingId} includeTrialDaysOnCta={t21} plan={nonCatalogPersonalPlan} directCheckout={t22} purchaseCtaText={t23} customSubtitle="Join 5 lakh+ learners on Personal Plan today" noticeData={t24} />;
    $[93] = T2;
    $[94] = categoryStats.isSubCopyEnabled;
    $[95] = course.frontendTrackingId;
    $[96] = handleCtaClick;
    $[97] = nonCatalogPersonalPlan;
    $[98] = t15;
    $[99] = t16;
    $[100] = t20;
    $[101] = t22;
    $[102] = t23;
    $[103] = t24;
    $[104] = t25;
  } else {
    t25 = $[104];
  }
  let t26;
  if ($[105] !== T1 || $[106] !== t14 || $[107] !== t25 || $[108] !== t6 || $[109] !== t7 || $[110] !== t8 || $[111] !== t9) {
    t26 = <T1 expanded={t6} title={t7} onExpand={t8}>{t9}{t14}{t25}</T1>;
    $[105] = T1;
    $[106] = t14;
    $[107] = t25;
    $[108] = t6;
    $[109] = t7;
    $[110] = t8;
    $[111] = t9;
    $[112] = t26;
  } else {
    t26 = $[112];
  }
  return t26;
};
function _temp(contentCollection) {
  return contentCollection.stats;
}